import { useHistory } from "react-router-dom";

export const goBackToBaseStaff = (history: ReturnType<typeof useHistory>) => {
  if (window.history.length > 1) {
    history.goBack();

    return;
  }

  history.replace("/base/staff/");
};
